// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordPage_container__kk86E","header":"ForgotPasswordPage_header__Mr7uJ"};